import { 
  getPaymentList,
  getPaymentDetail,
  getReportPageList,
  getUnfinalizedList,
  getPayType,
  getSettlementDetail
} from "@/api/settlement";
import { getPaymentTermsList } from "@/api/driver";
import cloneDeep from "lodash/cloneDeep";
import Vue from "vue";

const state = {
  namespaced: true,
  state: {
    driverList: [],
    driverListTotal: 0,
    paymentDetail: {},
    reportPageList: [],
    reportCount: 0,
    settlementDetail:[],
    reportDriverList: [],
    driverPickId: {},
    currentPaymentTerms: {},
    loadPaymentColumns: [
      {
        fieldName: "loadId",
        caption: "Load ID",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "52px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "status",
        caption: "Status",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "88px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "pickupTime",
        caption: "Pickup Date",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "81px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "route",
        caption: "Route",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "230px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "deliveryTime",
        caption: "Deliver Date",
        fixed: "",
        textAlignment: "left",
        allowSort: false,
        minWidth: "81px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "revenue",
        caption: "Revenue",
        fixed: "",
        textAlignment: "right",
        allowSort: false,
        minWidth: "52px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      },
      {
        fieldName: "settlement",
        caption: "Settlement",
        fixed: "",
        textAlignment: "right",
        allowSort: false,
        minWidth: "75px",
        params: {
          noClickCell: true,
        },
        type: "slot",
      }
    ],
    unfinalizedList: [],
    termsType: {},
  },
  mutations: {
    SET_DRIVERLIST(state, payload) {
      state.driverList = cloneDeep(payload).sort((x, y) => y.amount - x.amount);
    },
    SET_DRIVERTOTAL(state, payload) {
      state.driverListTotal = payload;
    },
    SET_PAYMENTDETAIL(state, payload) {
      let loadPaymentList = [];
      if (payload.loadPaymentList) payload.loadPaymentList.forEach(item => {
        loadPaymentList.push(Object.assign({}, item, {
          id: item.loadId
        }));
      })
      state.paymentDetail = Object.assign({}, payload, { loadPaymentList });
    },
    SET_SETTLEMENTDETAIL(state, payload) {
      state.settlementDetail = payload
    },
    SET_REPORTPAGELIST(state, payload) {
      state.reportPageList = payload;
    },
    SET_REPORTCOUNT(state, payload) {
      state.reportCount = payload;
    },
    SET_REPORTDRIVERLIST(state, payload) {
      if (!payload) return;
      let data = JSON.stringify(payload);
      if (JSON.stringify(state.reportDriverList) === data) return;
      state.reportDriverList = JSON.parse(data);
    },
    SET_DRIVERPICKID(state, payload) {
      state.driverPickId = payload;
    },
    SET_CURRENTPAYMENTTERMS(state, payload) {
      state.currentPaymentTerms = payload;
    },
    SET_UNFINALIZEDLIST(state, payload) {
      state.unfinalizedList = payload;
    },
    SET_TERMSTYPE(state, payload) {
      state.termsType = payload;
    }
  },
  actions: {
    async getDriverList({ commit }) {
      let { res } = await getPaymentList();
      if (res.data.code !== 200) {
        throw new Error(res.data.message);
      }
      commit("SET_DRIVERLIST", res.data.data.list);
      commit("SET_DRIVERTOTAL", res.data.data.total);
    },
    async getDriverPaymentDetail({ commit }, payload) {
      let { res } = await getPaymentDetail(payload);
      let res2 = await getPaymentTermsList(payload);
      if (res.data.code !== 200) {
        commit("SET_PAYMENTDETAIL", {});
        throw new Error(res.data.message)
      }
      if (res2.res.data.code !== 200) {
        commit("SET_CURRENTPAYMENTTERMS", {});
        throw new Error(res2.res.data.message);
      }
      commit("SET_CURRENTPAYMENTTERMS", res2.res.data.data);
      commit("SET_PAYMENTDETAIL", res.data.data);
    },
    async getDriverSettlementDetail({ commit }, payload) {
      let { res } = await getSettlementDetail(payload);
      if (res.data.code !== 200) {
        commit("SET_SETTLEMENTDETAIL", {});
        throw new Error(res.data.message)
      }
      commit("SET_SETTLEMENTDETAIL", res.data.data);
    },
    async getReportPage({ commit }, payload) {
      let { res } = await getReportPageList(payload);
      commit("SET_REPORTPAGELIST", res.data.data.content);
      commit("SET_REPORTCOUNT", res.data.data.totalElements);
      commit("SET_REPORTDRIVERLIST", res.data.data.driverList);
    },
    async getUnfinalizedList({ commit }, id) {
      await getUnfinalizedList(id).then(({ res }) => {
        const { code, message, data } = res.data;
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          return;
        }
        commit("SET_UNFINALIZEDLIST", data);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
      });
    },
    async getPayType({ commit }, id) {
      await getPayType(id).then(({ res }) => {
        const { code, message, data } = res.data;
        console.log(code, message, data);
        if (code !== 200) {
          Vue.prototype.$message.error(message);
          return;
        }
        commit("SET_TERMSTYPE", data);
      }).catch(({ error }) => {
        Vue.prototype.$message.error(error.message);
      });
    }
  },
}

export default state;